<template>
  <div>
    <div v-if="!disconnected && status && !loading">
        <b-card v-if="!Boolean(status && status.active)" style="font-size: x-large;">
          <b>리모트 모드로 전환해주세요.</b>
        </b-card>

        <b-card v-if="status.sensor !== null">
          <b-row>
            <b-col>
              <b style="color: red; font-size: x-large">{{ status.sensor.temperature }} ℃</b> 
            </b-col>
            <b-col>
              <b style="color: blue; font-size: x-large">{{ status.sensor.humidity }} ％</b>
            </b-col>
          </b-row>
        </b-card>
        
        <div>
          <!-- {{ status }} -->
          <b-row v-for="device in status.boards" :key="device.name">
              <b-col colspan="12" v-show="device.able">
                  <b-card
                      style="
                          background-color: white; 
                          border: 2px ridge; 
                          font-size: x-large; 
                          margin-top: 0.1rem;
                          font-weight: bold;
                          margin: 0.5rem;
                      ">
                      
                      <table
                      style="width: -webkit-fill-available; border-collapse: separate; border-spacing: 0.3rem">
                          <tr>
                              <td 
                              colspan="2">
                                  {{ device.name }}
                              </td>
                              <td colspan="1" style="width: 25%;" >
                                  <b-button 
                                  :disabled="!status.active"
                                  @click="clickBtn(device, 'automation', true)"
                                  :class="`w-100 btn btn-${device.automation? 'success active': 'secondary inactive'}`">
                                      자동
                                  </b-button>
                              </td>
                              <td colspan="1" style="width: 25%">
                                  <b-button 
                                  :disabled="!status.active"
                                  @click="clickBtn(device, 'automation', false)"
                                  :class="`w-100 btn btn-${device.automation? 'secondary inactive': 'warning active'}`">
                                      수동
                                  </b-button>
                              </td>
                          </tr>
                          <tr style="margin-top: 0.5rem;">
                              <td colspan="2" style="width: 50%;" >
                                  <b-button 
                                    size="lg" 
                                    @click="clickBtn(device, 'work', true)"
                                    :disabled="Boolean(device.automation) || !Boolean(status.active) || (findAlert(device.name)? true: false)"
                                    :class="`w-100 btn-${Boolean(device.work)? 'success active': 'secondary inactive'}`"
                                  > ON </b-button>
                              </td>
                              <td colspan="2" style="width: 50%">
                                  <b-button 
                                    size="lg" 
                                    @click="clickBtn(device, 'work', false)"
                                    :disabled="Boolean(device.automation) || !Boolean(status.active) || (findAlert(device.name)? true: false)"
                                    :class="`w-100 btn-${Boolean(device.work)? 'secondary inactive': 'danger active'}`"
                                  > OFF </b-button>
                              </td>
                          </tr>
                          <tr v-show="!findAlert(device.name)">
                            <th colspan="4" :style="{backgroundColor: showDeviceStatus(device.status).color, color: 'black'}">
                              - {{showDeviceStatus(device.status).text}} -
                            </th>
                            
                          </tr>
                          <tr v-show="findAlert(device.name)">
                            <th colspan="4" style="background-color: yellow; color: black">
                              {{ findAlert(device.name) }}
                            </th>
                          </tr>
                      </table>
                  </b-card>
                </b-col>
          </b-row>
        </div>
    </div>
    <div v-if="disconnected">
        <h3>연결이 끊겼습니다.</h3>
    </div>
    <div v-if="loading">
      <h3 style="font-weight:bold; font-size: 1.2em;" class="mt-1">
          <b-spinner variant="warning" label="Spinning" class="mt-1"></b-spinner>
          <br><br>
          <b>잠시만 기다려 주세요...</b>
          <br>
      </h3>
    </div>
    <!-- <button @click="sendPing">Ping 서버로 보내기</button> -->
    
    
  </div>
</template>

<script>
import { 
    BFormCheckbox,
    BButtonGroup,
    BInputGroup,
    BFormInput,
    BButton,
    BTable,
    BSpinner,
    BCard,
    BBadge,
    BRow,
    BCol,
} from 'bootstrap-vue'
import { io } from "socket.io-client";

export default {
  components: {
        BFormCheckbox,
        BButtonGroup,
        BInputGroup,
        BFormInput,
        BButton,
        BTable,
        BSpinner,
        BCard,
        BBadge,
        BRow,
        BCol,
    },
    props: {
        buttonItem: {
            type: Object,
            required: true,
        }
    },
  data() {
    return {
      socket: null,
      serverMessage: "",
      disconnected: false,
      status: null,
      loading: false,
      alertList: null
    };
  },
  created() {
    
    this.initSocket()

    // 🔹 브라우저 visibility 이벤트 등록
    document.addEventListener("visibilitychange", this.handleVisibility)
  },
  beforeDestroy() {
    if (this.socket) this.socket.disconnect()
    document.removeEventListener("visibilitychange", this.handleVisibility)
  },
  methods: {
    // ✅ 소켓 초기화 함수
    initSocket() {
      this.loading = true
      this.socket = io(
        window.location.protocol === "https:"
          ? "wss://app.e-farm.site"
          : "ws://127.0.0.1:3007",
        { 
          transports: ["websocket"],
          path: "/socket.io/",
        }
        
      );

      this.socket.on("connect", () => {
        this.socket.emit("requestDeviceConnect", { data: this.buttonItem });
      });

      this.socket.on("errPage", () => {
        this.disconnected = true
      });

      this.socket.on("status", (data) => {
        this.disconnected = false
        this.status = data
        this.loading = false
        this.alertList = data.alertList
      });
    },

    // ✅ 브라우저 탭/앱의 포그라운드 ↔ 백그라운드 상태 관리
    handleVisibility() {
      if (document.hidden) {
        // 🔻 백그라운드 전환 시 소켓 끊기
        if (this.socket) {
          this.socket.disconnect()
          console.log("Background ON.. socket pause")
        }
      } else {
        // 🔺 다시 포그라운드로 돌아왔을 때 소켓 재연결
        console.log("Reconnect Socket...!")
        this.initSocket()
      }
    },

    clickBtn (device, type, val) {
      this.socket.emit('controlBtn', {
        device, type, val
      })
    },
    showDeviceStatus(status) {
      switch(status) {
        case 'stop': return {text: '정지', color: 'lightgrey'}
        case 'open': return {text: '열림중', color: 'lime'}
        case 'close': return {text: '닫힘중', color: 'tomato'}
        case 'work': return {text: '동작중', color: 'skyblue'}
        default: return {text: '알림', color: 'yellow'}
      }
    },
    findAlert(ID) {
      const alert = this.alertList?.find(e => e.ID === ID)
      return alert ? alert.msg : null
    }
  },
}
</script>
